import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { CSSTransitionGroup } from 'react-transition-group';
import Search from "./Search";
import { FormControl } from "react-bootstrap";

import { fetchCompany, fetchVideoTemplates } from "../actions/index";

export class VideoTemplatesList extends Component {
  static propTypes = {
    fetchVideoTemplates: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    videoTemplates: PropTypes.object
  };

 constructor(props) {
    super(props);
    this.state = {
      enabled: true,
      site_domain: null,
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.status == 200) {
        this.setState({ site_domain: response.payload.data.data.site_domain });
        this.fetchData();
      }
    });
  }

  fetchData() {
    let newQueries = { page: 1, per_page: 10000 };
    this.props.fetchVideoTemplates(
      this.serialize(newQueries)
    );
  }

  serialize(obj) {
    return (
      "?" +
      Object.keys(obj)
        .reduce(function(a, k) {
          a.push(k + "=" + encodeURIComponent(obj[k]));
          return a;
        }, [])
        .join("&")
    );
  }

  renderVideoTemplates() {
    if (!this.props.videoTemplates.data) {
      return (
        <tr>
          <td colSpan={6}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.videoTemplates.data.length == 0) {
      return (
        <tr>
          <td colSpan={6}>
            <div className="well well-lg text-center">
              You have no videos.&nbsp;
              <Link to={`/video_templates/new`} >
                Click here to create one.
              </Link>
            </div>
          </td>
        </tr>
      );
    }

    return this.props.videoTemplates.data.map(videoTemplate => {
      return (
        <tr key={videoTemplate.id}>
          <td>
            <a
              href={`http://${this.state.site_domain}/vid/${videoTemplate.video_uuid}`}
              target='_blank'
              rel="noreferrer"
            >
              <img className='video_thumbnail' src={videoTemplate.thumbnail_url}/>
            </a>
          </td>
          <td>
            <Link to={`/video_templates/${videoTemplate.id}`} >
              {videoTemplate.name.slice(0, 20)}
            </Link>
          </td>
          <td>{videoTemplate.created_at}</td>
          <td>{videoTemplate.duration}</td>
          <td className="text-right">
            <div
              className="btn btn-sm btn-default template_edit"
              onClick={this.props.handleInsertVideoLink.bind(this, videoTemplate.thumbnail_url)}
            >
              Insert
            </div>
          </td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (this.props.videoTemplates.meta) {
      count = this.props.videoTemplates.meta.count;
    }
    if (this.state.enabled == true) {
      return (
        <div className="video_templates_list">
          <div className="row">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th className={`template_name`} >
                    Name
                  </th>
                  <th className={`template_created_at`} >
                    Created At
                  </th>
                  <th className={`template_duration`} >
                    Duration
                  </th>
                  <th className="text-right" />
                </tr>
              </thead>
              <tbody>{this.renderVideoTemplates()}</tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return (
        <div className="templates_index">
          <div className="row">
            <h1>
              Video
            </h1>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return { videoTemplates: state.videoTemplates.all };
}

export default connect(
  mapStateToProps,
  { fetchCompany, fetchVideoTemplates }
)(VideoTemplatesList);
